import React, { Fragment, useEffect, useState, useMemo, useCallback } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { isInteger, useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions

import { getEmployee, resetEmployeeState } from "../../../store/employee/action";
import { getWorkGroup, resetWorkGroupState } from "../../../store/workGroup/action";
import { resetAccSettingState, getAccSetting as onGetAccSettings, addNewAccSetting as onAddNewAccSetting, updateAccSetting as onUpdateAccSetting, deleteAccSetting as onDeleteAccSetting, getAccSettingLoading } from "../../../store/accSetting/action";
import { resetPayrollSalaryState, getPayrollSalary as onGetPayrollSalarys, addNewPayrollSalary as onAddNewPayrollSalary, updatePayrollSalary as onUpdatePayrollSalary, deletePayrollSalary as onDeletePayrollSalary, getPayrollSalaryLoading } from "../../../store/payrollSalary/action";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import defaultImg from "../../../assets/images/users/user-dummy-img.jpg";
import ExportCSVModal from "../../../Components/Common/ExportCSVModal";

import Leaflet from "leaflet";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";
let DefaultIcon = Leaflet.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});
Leaflet.Marker.prototype.options.icon = DefaultIcon;

const PayrollSalary = () => {
  const [modal, setModal] = useState(false);
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, employees, accSettings, isAccSettingCreated, isAccSettingSuccess, workGroupLoading, payrollSalarys, isPayrollSalaryCreated, isPayrollSalarySuccess, loading, error, permissionCategories, permissionCategoryLoading, workGroups } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    accSettings: state.AccSetting.accSettings,
    isAccSettingCreated: state.AccSetting.isAccSettingCreated,
    isAccSettingSuccess: state.AccSetting.isAccSettingSuccess,
    payrollSalarys: state.PayrollSalary.payrollSalarys,
    isPayrollSalaryCreated: state.PayrollSalary.isPayrollSalaryCreated,
    isPayrollSalarySuccess: state.PayrollSalary.isPayrollSalarySuccess,
    loading: state.PayrollSalary.loading,
    permissionCategories: state.PermissionCategory.permissionCategories,
    permissionCategoryLoading: state.PermissionCategory.loading,
    workGroups: state.WorkGroup.workGroups,
    workGroupLoading: state.WorkGroup.workGroupLoading,
    error: state.PayrollSalary.error,
    employees: state.Employee.employees,
  }));

  const [payrollSalaryList, setPayrollSalaryList] = useState([]);
  const [absentCompensation, setAbsentCompensation] = useState(0);
  const [payrollSalary, setPayrollSalary] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [permissionCategoryList, setPermissionCategoryList] = useState([]);
  const [approveModal, setApproveModal] = useState(false);
  const [info, setInfo] = useState([]);
  const [locationCord, setLocationCord] = useState([0, 0]);
  const [days, setDays] = useState(0);

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [employeeList, setEmployeeList] = useState([]);
  const [workGroupList, setWorkGroupList] = useState([]);
  const [dataCsv, setDataCsv] = useState([]);

  const [printDoc, setPrintDoc] = useState([]);

  const typeOptionsList = [
    {
      label: "Jam Masuk",
      value: "clock_in",
    },
    {
      label: "Jam Pulang",
      value: "clock_out",
    },
    {
      label: "Jam Mulai Istirahat",
      value: "break_in",
    },
    {
      label: "Jam Selesai Istirahat",
      value: "break_out",
    },
    {
      label: "Jam Masuk Lembur",
      value: "over_in",
    },
    {
      label: "Jam Keluar Lembur",
      value: "over_out",
    },
  ];

  const onClickDelete = (payrollSalary) => {
    setPayrollSalary(payrollSalary);
    setDeleteModal(true);
  };

  const handleDeletePayrollSalary = () => {
    if (payrollSalary) {
      dispatch(onDeletePayrollSalary(payrollSalary));
      setDeleteModal(false);
    }
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    setPayrollSalaryList(payrollSalarys);

    let listData = [];
    let totalTf = 0;

    payrollSalarys.forEach((e) => {
      let noRek = "";

      if (e?.employee_user?.user_contract?.length > 0) {
        if (e.employee_user.user_payrate[0]?.rates !== "100.00") {
          e.employee_bank.forEach((b) => {
            if (b.isPrimary === true) {
              noRek = b.number;
            }
          });

          const rates = parseFloat(e.employee_user.user_payrate[0]?.rates);

          totalTf += rates;

          listData.push(`${noRek},${e.name},${rates},Penggajian PT. Pesona Kahuripan,-,-,Y,${e.employee_user.email},,N,${e.code}`);
        }
      }
    });

    const dataString = listData.join(`
    `);

    const csvFormat = `Tanggal,Rekening sumber,Jumlah Record,Total Transfer,,,,,,,
    ${moment().format("YYYY/MM/DD").toString()},0136498681001,${listData.length},${totalTf},,,,,,,
    rekening tujuan,nama rekening,jumlah transfer,narasi,narasi 2,narasi 3,Notifikasi email,email penerima,Sender reference number,Pembayaran Final,Beneficiary ref num
    ${dataString}
    `;

    setDataCsv(csvFormat);
  }, [payrollSalarys]);

  useEffect(() => {
    if (companySelected) {
      dispatch(resetPayrollSalaryState());
      dispatch(onGetPayrollSalarys({ companyId: companySelected?.value ?? "" }));
      dispatch(resetWorkGroupState());
      dispatch(getWorkGroup({ companyId: companySelected?.value ?? "" }));
    }
  }, [companySelected]);

  useEffect(() => {
    if (!isEmpty(payrollSalarys)) {
      setPayrollSalaryList(payrollSalarys);
      if (payrollSalarys.length > 1) {
        setInfo(payrollSalarys[payrollSalarys.length - 1]);

        // let location = payrollSalarys[payrollSalarys.length - 1].clocationin.split(",");
        // setLocationCord([
        //   location[0] ? location[0] : 0,
        //   location[1] ? location[1] : 0,
        // ]);
      }
      setIsEdit(false);
    }
  }, [payrollSalarys]);

  useEffect(() => {
    setPayrollSalaryList(payrollSalarys);
  }, [payrollSalarys]);

  useEffect(() => {
    if (!isEmpty(payrollSalarys)) setPayrollSalaryList(payrollSalarys.map((el) => ({ ...el, isChecked: false })));
  }, [payrollSalarys]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "location_user",
        label: "Nama",
        isSelected: true,
        data: [],
      },
      {
        id: "location_branch",
        label: "Cabang",
        isSelected: true,
        data: [],
      },
      {
        id: "isPrimary",
        label: "Primary",
        isSelected: true,
        data: [],
      },
    ];

    if (payrollSalaryList.length > 0) {
      payrollSalaryList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);
            if (doc) {
              if (doc.id === "location_user" || doc.id === "location_branch") {
                doc.data.push(value?.name ?? "-");
              } else if (doc.id === "isPrimary") {
                doc.data.push(value ? "Primary" : "-");
              } else {
                doc.data.push(value ?? "-");
              }
            }
          });
        }
      });
    }

    setPrintDoc(dataDoc);
  }, [payrollSalaryList]);

  function handleEmployee(e) {
    if (e.length > 2) {
      dispatch(getEmployee({ title: e, status: 2 }));
    }
    return false;
  }

  useEffect(() => {
    if (!isEmpty(permissionCategories)) {
      var permissionCategoryData = [];
      var opt = [];
      permissionCategories.forEach((item, key) => {
        const category_name = item.category_name;
        const id = item.id;
        const type = item.type;
        if (item.type === "payrollSalary") {
          var obj = {
            label: category_name,
            value: id,
            type: type,
          };
          opt.push(obj);
        }
      });
      var option = { options: opt };
      permissionCategoryData.push(option);
      setPermissionCategoryList(permissionCategoryData);
    }
  }, [permissionCategories]);

  useEffect(() => {
    if (!isEmpty(workGroups)) {
      var data = [];
      var opt = [];
      workGroups.forEach((item, key) => {
        const group_name = item.group_name + " - " + item.wg_company.name;
        const id = item.id;
        const companyId = item.companyId;
        var obj = { label: group_name, value: id, companyId: companyId };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setWorkGroupList(data);
    }
  }, [workGroups]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setPayrollSalary(null);
    } else {
      setModal(true);
    }
  }, [modal]);

  const handlePayrollSalaryClick = useCallback(
    (arg) => {
      const data = arg;

      setPayrollSalary({
        id: data.id,
        startat: `${data.payrollSalary_date} ${data.clockinat}`,
        workGroup: {
          label: data.group_name,
          value: data.workGroupId,
          companyId: data.companyId,
          clientId: data.clientId,
          componentId: data.componentId,
        },
      });

      setIsEdit(true);
      toggle();
    },
    [toggle]
  );

  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".dataCheckbox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeletePayrollSalary(element.value));
    });
    checkall.checked = false;
  };

  const handleApprovePermissionCategory = () => {
    if (payrollSalary) {
      payrollSalary.setApprove = true;
      dispatch(onUpdatePayrollSalary(payrollSalary));
      dispatch(resetPayrollSalaryState());
      dispatch(onGetPayrollSalarys());
      setApproveModal(false);
    }
  };

  const columns = useMemo(
    () => [
      // {
      //   Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()} />,
      //   Cell: (cellProps) => {
      //     return <input type="checkbox" className="dataCheckbox form-check-input" value={cellProps.row.original.id} />;
      //   },
      //   id: "#",
      // },
      // {
      //   Header: " ",
      //   filterable: false,
      //   Cell: (cellProps) => {
      //     return (
      //       <div className="hstack gap-2 mt-4 mt-sm-0">
      //         <Link
      //           to="#"
      //           className="btn-icon btn btn-sm btn-light"
      //           onClick={() => {
      //             const payrollSalaryData = cellProps.row.original;
      //             setInfo(payrollSalaryData);
      //           }}
      //         >
      //           <i className="ri-eye-line fs-15"></i>
      //         </Link>
      //         <Link
      //           to="#"
      //           className={userType === "admin" || userType === "client" || userType === "company" ? "btn-icon btn btn-sm btn-light edit-item-btn" : userRole && userRole.split(",").indexOf("updatePayrollSalary") !== -1 ? "btn-icon btn btn-sm btn-light edit-item-btn" : "btn-icon btn btn-sm btn-light edit-item-btn d-none"}
      //           onClick={() => {
      //             const payrollSalaryData = cellProps.row.original;
      //             handlePayrollSalaryClick(payrollSalaryData);
      //           }}
      //         >
      //           <i className="ri-edit-2-line fs-15"></i>
      //         </Link>
      //       </div>
      //     );
      //   },
      // },
      // {
      //   Header: "Nama",
      //   accessor: "payroll_employee.name",
      //   filterable: true,
      // },
      // {
      //   Header: "Work Group",
      //   accessor: "workGroupName",
      //   filterable: true,
      //   Cell: (rates) => <> {rates.row.original.payroll_group.group_name + " - " + rates.row.original.payroll_company.name} </>,
      // },
      // {
      //   Header: "Tanggal Absensi",
      //   accessor: "tanggalAbsensi",
      //   filterable: true,
      //   Cell: (rates) => <> {handleValidDate(rates.row.original.startat) + " - " + handleValidDate(rates.row.original.endat)} </>,
      // },
      // {
      //   Header: "Status",
      //   accessor: "payroll_status.name",
      //   filterable: true,
      //   Cell: (cell) => {
      //     switch (cell.value) {
      //       case "DRAFT":
      //         return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
      //       case "ACTIVE":
      //         return <span className="badge text-uppercase badge-soft-info">{cell.value}</span>;
      //       case "INACTIVE":
      //         return <span className="badge text-uppercase badge-soft-danger">{cell.value}</span>;
      //       default:
      //         return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
      //     }
      //   },
      // },
    ],
    [handlePayrollSalaryClick, userType, userRole]
  );

  const defaultdate = () => {
    return moment().format("YYYY/MM/DD HH:mm:ss").toString();
  };

  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = (date) => {
    const dt = new Date(date);
    return moment(new Date(date), "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const handleValidTime = (time) => {
    return moment(new Date(time), "YYYY/MM/DD").format("HH:mm");
  };

  //TABLE
  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: payrollSalaryList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 10,
        selectedRowIds: 0,
        // sortBy: [
        //   {
        //     desc: false,
        //   },
        // ],
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 600);

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      companyId: companySelected?.value ?? "",
    };
    dispatch(onGetPayrollSalarys(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setPayrollSalaryList([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    dispatch(resetPayrollSalaryState());
    dispatch(onGetPayrollSalarys({ companyId: companySelected?.value ?? "" }));
  };
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      employee: payrollSalary && payrollSalary.employee,
      payrollat: payrollSalary && payrollSalary.startat,
      permissionCategory: payrollSalary && payrollSalary.permissionCategory,
      startAt: "",
      endAt: "",
      type: payrollSalary && payrollSalary.type,
      hours: 0,
      isTHR: false,
      isKPI: false,
      days: days,
    },
    validationSchema: Yup.object({
      // permissionCategory: Yup.object().required(
      //   "Please Pick permissionCategory"
      // ),
      // employee: Yup.object().required("Please Pick Employee"),
      // startat: Yup.string().required("Please Pick Effective Date"),
      // type: Yup.object().required("Please Pick Type"),
    }),
    onSubmit: (values) => {
      dispatch(getPayrollSalaryLoading());
      if (isEdit) {
        const updatePayrollSalary = {
          id: payrollSalary ? payrollSalary.id : 0,
          startat: values.startat,
          type: values.type.value,
          workGroupId: values.workGroup.value,
        };

        dispatch(onUpdatePayrollSalary(updatePayrollSalary));
        validation.resetForm();
      } else {
        const newPayrollSalary = {
          payrollat: values.payrollat,
          groupId: values.workGroup.value,
          hours: values.hours,
          isTHR: values.isTHR,
          isKPI: values.isKPI,
          startat: values.startAt,
          endat: values.endAt,
          days: values.days,
          // type: "clock_in",
        };
        dispatch(onAddNewPayrollSalary(newPayrollSalary));
        validation.resetForm();
      }
      toggle();
    },
  });

  const getAccSettingHandle = (companyId) => {
    dispatch(onGetAccSettings({ companyId: companyId }));
  };

  useEffect(() => {
    if (accSettings) {
      if (accSettings.absent_compensation !== null) {
        setDays(accSettings.absent_compensation);
      } else {
        setDays(0);
      }
    }
  }, [accSettings]);

  document.title = "Perhitungan Gaji | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={dataCsv} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeletePayrollSalary} onCloseClick={() => setDeleteModal(false)} />
      <Container fluid>
        <BreadCrumb title="Penggajian" pageTitle="Perhitungan Gaji" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createPayrollSalary") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
              id="create-btn"
              onClick={() => {
                if (!isEdit) {
                  setPayrollSalary((payrollSalary) => ({
                    ...payrollSalary,
                    type: typeOptionsList[0],
                  }));
                }
                setIsEdit(false);
                toggle();
              }}
            >
              <i className="ri-map-pin-time-line me-1 align-bottom fs-14"></i> Tambah
            </button>
            <button type="button" className="btn btn-success me-1" onClick={() => setIsExportCSV(true)}>
              <i className="ri-file-download-line me-1 align-bottom fs-14"></i> Export
            </button>
          </div>
        </BreadCrumb>
        <Row>
          <Col xxl={7}>
            <Card id="payrollSalaryList">
              <CardBody className="pt-0">
                <div>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={2}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                            gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2} className="col-xxl-3">
                            <div className="search-box mb-2">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Pilih Tanggal"
                                value={filterDate}
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(selectedDates, dateStr) => {
                                  setFilterDate(dateStr);
                                }}
                              />
                              <i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2} className="col-xxl-3">
                            <div className="me-2 mb-2 col-12">
                              <Input name="employee_filter" id="employee_filter" className="form-control" placeholder="Isi Nama Karyawan" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.reason} />
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Ubah Perhitungan Gaji" : "Tambah Perhitungan Gaji"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}>
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="row">
                            <div className="mb-3">
                              <Label htmlFor="workGroup" className="form-label">
                                Grup Kerja
                                {workGroupLoading ? (
                                  <Spinner color="primary" size="sm">
                                    Loading...
                                  </Spinner>
                                ) : (
                                  ""
                                )}
                              </Label>
                              <Select
                                name="workGroup"
                                value={validation.values.workGroup}
                                placeholder="Enter Work Group"
                                onChange={(e) => {
                                  getAccSettingHandle(e.companyId);
                                  validation.setFieldValue("workGroup", e);
                                }}
                                // onInputChange={(e) => { handleEmployee(e) }}
                                options={workGroupList}
                                noOptionsMessage={(e) => "Type Work Group to get option"}
                                invalid={validation.touched.workGroup && validation.errors.workGroup ? true : false}
                              ></Select>
                              {validation.touched.workGroup && validation.errors.workGroup ? (
                                <p className="text-danger" type="invalid">
                                  {validation.errors.workGroup}
                                </p>
                              ) : null}
                            </div>
                            {!!isEdit && (
                              <div className="mb-3">
                                <Label htmlFor="type" className="form-label">
                                  Tipe
                                </Label>
                                <Select
                                  name="type"
                                  value={validation.values.type}
                                  placeholder="Enter Jenis"
                                  onChange={(e) => {
                                    validation.setFieldValue("type", e);
                                  }}
                                  options={typeOptionsList}
                                  invalid={validation.touched.type && validation.errors.type ? true : false}></Select>
                                {validation.touched.type && validation.errors.type ? (
                                  <p className="text-danger" type="invalid">
                                    {validation.errors.type}
                                  </p>
                                ) : null}
                              </div>
                            )}
                            <div className="mb-3">
                              <Label htmlFor="date-field" className="form-label">
                                Tanggal Penggajian
                              </Label>
                              <Flatpickr
                                name="startat"
                                className="form-control"
                                placeholder="Pilih Tanggal"
                                options={{ enableTime: false, time_24hr: false, altInput: false, altFormat: "Y/m/d", dateFormat: "Y/m/d" }}
                                value={validation.values.payrollat ?? ""}
                                onChange={(o, e) => {
                                  validation.setFieldValue("payrollat", e);
                                }}
                              />
                              {validation.touched.payrollat && validation.errors.payrollat ? (
                                <p className="text-danger" type="invalid">
                                  {validation.errors.payrollat}
                                </p>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <Label htmlFor="date-field" className="form-label">
                                Periode Presensi
                              </Label>
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Pilih Periode Presensi"
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(selectedDates, dateStr) => {
                                  const dates = dateStr.replace("to", "").split("  ");
                                  validation.setFieldValue("startAt", dates[0]);
                                  validation.setFieldValue("endAt", dates[1]);
                                }}
                              />

                              {validation.touched.startAt && validation.errors.startAt ? (
                                <p className="text-danger" type="invalid">
                                  {validation.errors.startAt}
                                </p>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <label className="form-label" htmlFor="price">
                                Jam Kerja/Hari
                              </label>
                              <div className="input-group mb-3">
                                <Input
                                  type="number"
                                  className="form-control"
                                  id="price"
                                  placeholder="Enter price"
                                  name="price"
                                  value={validation.values.hours}
                                  onBlur={(e) => {
                                    if (validation.values.hours === "") {
                                      validation.setFieldValue("hours", 0);
                                    }
                                  }}
                                  onChange={(e) => {
                                    validation.setFieldValue("hours", e.target.value);
                                    // validation.handleChange
                                  }}
                                  invalid={validation.touched.hours && validation.errors.hours ? true : false}
                                />
                                {validation.touched.hours && validation.errors.hours && (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.hours}
                                  </small>
                                )}
                              </div>
                            </div>
                            <div className="mb-3">
                              <label className="form-label" htmlFor="price">
                                Jadwal Hari Kerja
                              </label>
                              <div className="input-group mb-3">
                                <Input
                                  type="number"
                                  className="form-control"
                                  id="price"
                                  placeholder="Isi Jadwal Hari Kerja"
                                  name="price"
                                  value={validation.values.days}
                                  onBlur={(e) => {
                                    if (validation.values.days === "") {
                                      validation.setFieldValue("days", 0);
                                    }
                                  }}
                                  onChange={(e) => {
                                    validation.setFieldValue("days", e.target.value);
                                    // validation.handleChange
                                  }}
                                  invalid={validation.touched.days && validation.errors.days ? true : false}
                                />
                                {validation.touched.days && validation.errors.days && (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.days}
                                  </small>
                                )}
                              </div>
                            </div>
                            <div className="mb-3">
                              <Input name="isTHR" id="isTHR-field" className="form-check-input" type="checkbox" onChange={validation.handleChange} onBlur={validation.handleBlur} checked={validation.values.isTHR} /> &nbsp;
                              <Label htmlFor="isTHR-field" className="form-label">
                                Tunjangan Hari Raya ?
                              </Label>
                            </div>
                            <div className="mb-3">
                              <Input name="isKPI" id="isKPI-field" className="form-check-input" type="checkbox" onChange={validation.handleChange} onBlur={validation.handleBlur} checked={validation.values.isKPI} /> &nbsp;
                              <Label htmlFor="isWFA-field" className="form-label">
                                Key Performance Indicator ?
                              </Label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{"Simpan"}</span>
                            {/* {loading && (
                                <Spinner
                                  size="sm"
                                  className="flex-shrink-0"
                                  role="reason">Loading...</Spinner>
                              )} */}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
              </CardBody>
            </Card>
          </Col>
          <Col xxl={5}>
            <Card>
              <div className="card-body">
                <div className="table-card p-2">
                  <table className="table table-responsive table-striped mb-3">
                    <tbody>
                      <tr>
                        <td className="p-2 pt-3 fw-medium text-primary text-uppercase" colSpan={"2"}>
                          Presensi
                        </td>
                      </tr>

                      <tr>
                        <td className="p-2">Jadwal Hari Kerja</td>
                        <td className="p-2">{Math.round(info.payroll_attendance)}</td>
                      </tr>
                      <tr>
                        <td className="p-2">Hadir</td>
                        <td className="p-2">{Math.round(info.actual_attendance)}</td>
                      </tr>
                      <tr>
                        <td className="p-2">Perijinan</td>
                        <td className="p-2">{Math.round(info.permission)}</td>
                      </tr>
                      <tr>
                        <td className="p-2">Alpha</td>
                        <td className="p-2">{Number(info.payroll_attendance) - (Number(info.actual_attendance) + Number(info.permission))}</td>
                      </tr>
                      <tr>
                        <td className="p-2">Gaji</td>
                        <td className="p-2">{Number(info.rates)}</td>
                      </tr>
                      {(info.payroll_details || []).map((detail, i) => {
                        return (
                          detail.detail_name === "Gaji Pokok" && (
                            <tr key={detail.id}>
                              <td className="p-2">Gaji</td>
                              <td className="p-2">{Number(detail.total)}</td>
                            </tr>
                          )
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                <div className="table-card table-responsive">
                  <p className="p-2 pt-3 fw-medium text-primary text-uppercase">Tunjangan</p>
                  <table className="table border table-striped fs-13 mb-3">
                    <thead className="table-light">
                      <tr>
                        <th>Nama</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(info.payroll_details || []).map((detail, i) => {
                        return (
                          detail.component_type === "Allowance" && (
                            <tr key={detail.id}>
                              <td>{detail.detail_name}</td>
                              <td>{detail.total}</td>
                            </tr>
                          )
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                <div className="table-card table-responsive">
                  <p className="p-2 pt-3 fw-medium text-primary text-uppercase">Potongan</p>
                  <table className="table border table-striped fs-13 mb-3">
                    <thead className="table-light">
                      <tr>
                        <th>Nama</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(info.payroll_details || []).map((detail, i) => {
                        return (
                          detail.component_type === "Deduction" && (
                            <tr key={detail.id}>
                              <td>{detail.detail_name}</td>
                              <td>{detail.total}</td>
                            </tr>
                          )
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PayrollSalary;
